import { StateCreator } from 'zustand';

import { DEFAULT_AUTH_PATH } from '../routeStore/constants/authPath';
import { SignOutOptions } from './types/SignOutOptions';
import { SignOutState } from './types/SignOutState';
import { SignOutStateDependencies } from './types/SignOutStateDependencies';

export const signOutStore =
  ({
    resetAllStores,
    useApiStore,
    useRouteStore,
  }: SignOutStateDependencies): StateCreator<SignOutState> =>
  (set, get) => ({
    isSigningOut: false,
    signOutMessage: null,

    signOut: (options?: SignOutOptions): Promise<void> => {
      const { isSigningOut } = get();

      if (isSigningOut) {
        return;
      }

      const { setAuthRedirectPath } = useRouteStore.getState();

      const portalHttpRequest = useApiStore.getState().portalApi();

      set({ isSigningOut: true });

      return portalHttpRequest
        .delete('/2.0/session')
        .catch(() => {
          // ignore for now..
        })
        .finally(() => {
          // reset all stores to their initial state
          resetAllStores();

          // set the sign out message to display on the sign out page
          set({
            isSigningOut: false,
            signOutMessage: options?.withMessage,
          });

          // set the auth redirect path to where we'd want the user to go after signing back in.
          // if not provided, the user will be redirected to the default auth path after sign in.
          setAuthRedirectPath(
            options?.withAuthRedirectPath || DEFAULT_AUTH_PATH,
          );
        });
    },
  });
